import React, { memo, useEffect, useState } from "react"
import Link from "next/link"
import CardLiveShow from "components/CardLiveShow"
import TypeEvent from "utils/TypeEvent"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"

// eslint-disable-next-line react/display-name
const MySwiper = memo(({ name, events, id, type_block, display_type, isChannel, isCollapsed }) => {
  const [deVice, setDeVice] = useState("desktop")
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  function onChangePerView() {
    switch (type_block) {
      case TypeEvent.LIVESHOW: {
        if (display_type === DisplayTypeScreenBlock.HORIZONTAL) {
          if (deVice === "mobile") {
            return 1.8
          } else if (deVice === "ipad") {
            return 3.25
          } else {
            return 4.1
          }
        } else if (deVice === "mobile") {
          return 2.5
        } else if (deVice === "ipad") {
          return 3
        } else {
          return 6.2
        }
      }
      default:
        return 7
    }
  }

  function onChangePerGroup() {
    if (type_block === TypeEvent.LIVESHOW) {
      if (display_type === DisplayTypeScreenBlock.HORIZONTAL) {
        if (deVice === "mobile") {
          return 1
        } else if (deVice === "ipad") {
          return 3
        } else {
          return 4
        }
      } else {
        if (deVice === "mobile") {
          return 2
        } else if (deVice === "ipad") {
          return 4
        } else {
          return 6
        }
      }
    }
  }

  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  })

  return (
    <>
      {type_block !== TypeEvent.BANNER && (
        <>
          <Link href={`/danh-muc/${id}`}>
            <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8">
              <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">{name}</span>
              <div
                className={`flex items-center gap-[10px] text-primary text-xs sm:text-sm font-normal whitespace-nowrap`}
              >
                Xem thêm
              </div>
            </div>
          </Link>
          <div className="relative wapper__swiper__custom">
            <Swiper
              key={"liveshow"}
              slidesPerView={4}
              slidesPerGroup={4}
              // slidesPerView={onChangePerView()}
              // slidesPerGroup={onChangePerGroup()}
              spaceBetween={24}
              modules={[Navigation]}
              className={`${
                display_type === DisplayTypeScreenBlock.HORIZONTAL ? "swiper_card_horizontal" : "swiper_card_vertical"
              }`}
              navigation={true}
              breakpoints={{
                300: {
                  slidesPerView: 1.1,
                  slidesPerGroup: 1,
                  spaceBetween: 12
                },
                430: {
                  slidesPerView: 1.3,
                  slidesPerGroup: 1,
                  spaceBetween: 12
                },
                520: {
                  slidesPerView: 1.5,
                  slidesPerGroup: 1,
                  spaceBetween: 12
                },
                600: {
                  slidesPerView: 1.7,
                  slidesPerGroup: 1,
                  spaceBetween: 12
                },
                660: {
                  slidesPerView: 1.9,
                  slidesPerGroup: 1,
                  spaceBetween: 12
                },
                730: {
                  slidesPerView: 2.2,
                  slidesPerGroup: 1
                },
                815: {
                  slidesPerView: 2.4,
                  slidesPerGroup: 2
                },
                890: {
                  slidesPerView: 2.6,
                  slidesPerGroup: 2
                },
                965: {
                  slidesPerView: 2.8,
                  slidesPerGroup: 2
                },
                1055: {
                  slidesPerView: 3.1,
                  slidesPerGroup: 2
                },
                1170: {
                  slidesPerView: 3.3,
                  slidesPerGroup: 2
                },
                1200: {
                  slidesPerView: 2.7,
                  slidesPerGroup: 2
                },
                1255: {
                  slidesPerView: 2.9,
                  slidesPerGroup: 2
                },
                1310: {
                  slidesPerView: 3.1,
                  slidesPerGroup: 2
                },
                1400: {
                  slidesPerView: 3.3,
                  slidesPerGroup: 3
                },
                1460: {
                  slidesPerView: 3.5,
                  slidesPerGroup: 3
                },
                1536: {
                  slidesPerView: 3.7,
                  slidesPerGroup: 3
                },
                1600: {
                  slidesPerView: 3.9,
                  slidesPerGroup: 3
                },
                1685: {
                  slidesPerView: 4.2,
                  slidesPerGroup: 4
                },
                1775: {
                  slidesPerView: 4.4,
                  slidesPerGroup: 4
                },
                1850: {
                  slidesPerView: 4.6,
                  slidesPerGroup: 4
                }
              }}
            >
              {events?.length > 0 &&
                events?.map((item) => {
                  const { id } = item

                  return (
                    <SwiperSlide key={id}>
                      {type_block === TypeEvent.LIVESHOW && <CardLiveShow {...item} display_type={display_type} />}
                    </SwiperSlide>
                  )
                })}
            </Swiper>
          </div>
        </>
      )}
    </>
  )
})

export default MySwiper
